export default {
  OWNER: 'owner',
  ENTRY: 'entry',
  PACKAGE: 'package',
}
